import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import { clone, get } from "lodash";

import { getDateDiffs, formatDollar } from "../../../shared/utility";

import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import Button from "../../../components/CustomButtons/Button";
import CustomInput from "components/CustomInput/CustomInputValidate";
import LeaseCompany from "../CommonCustomElements/LeaseCompany";
import { getDateDifferenceHTML } from "../RSheetsLogic";
import {
    addTermRangesError,
    calculateEstimatedAbatedRanges,
    calculateEstimatedAbatedYearRanges,
    calculateEstimatedTermsTotal,
    calculateYearAbatedRanges,
    isEstimatedLease,
    isFlatFeeCommissionEnabled,
    calculateAbatedRanges_RS as calculateAbatedRanges,
    calculateStartingRent,
    makeAllRanges,
	newYearlyCalculation,
} from "../RSheetsLogic";

import termLogic from "../CommonCustomElements/Term/TermLogicMain";
import { Step3RentTotals } from "../CommonCustomElements/Term/TermLogicMain";
import TermEstimatedMain from "../CommonCustomElements/Term/Estimated/TermEstimatedMain";
import LeaseRangesBasedOff from "../CommonCustomElements/LeaseRangesBasedOff";
import PreLeaseForm from "../CommonCustomElements/PreLeaseForm";

const Step3 = (props) => {
    const { renderElement, data, setData, setOpenedCompanyModal, updateDataObj } = props;

    const isEstimated = isEstimatedLease(data);
    const shouldShowRanges = !isFlatFeeCommissionEnabled(data, true);
    const hideStartingRentPerSqft = get(data, 'flat_fee_space', '') === 'Yes';

    const prev_lease_length = usePrevious(data.lease_length);
    useEffect(() => {
        const newData = clone(data);
        if (isEstimated) {
            if (data.lease_length) {
                if (prev_lease_length !== undefined && prev_lease_length !== data.lease_length) {
                    let numOfYears = parseInt(parseInt(data.lease_length) / 12);
                    if (parseInt(data.lease_length) % 12 > 0) {
                        numOfYears += 1;
                    }
                    const terms = [];
                    for (let i = 1; i <= numOfYears; ++i) {
                        terms.push({
                            ranges: [],
                            year_end: null,
                            year_num: i,
                            year_start: null,
                        });
                    }
                    newData.abated_rent_ranges = clone(terms);
                    newData.lease_term = clone(terms);
                }
            } else {
                newData.abated_rent_ranges = [];
                newData.lease_term = [];
            }
        }
        setData(newData);
    }, [data.lease_length]);

    const typeOfLease = get(data, "type_of_lease", "");
    const isRenewal = typeOfLease === "Renewal";

    useEffect(() => {
        const newData = clone(data);
        if (isRenewal) {
            newData.occupancy_date = "Existing";
        } else {
            const occupancyDate = get(data, "occupancy_date", "");
            newData.occupancy_date = occupancyDate === "Existing" ? "" : occupancyDate;
        }
        setData(newData);
    }, [isRenewal]);

    const warning = "WARNING! Changing this value will erase the previous Lease Term and Abated Rent Range data. ";

    const calcs = termLogic.calculateLeaseTerm(data);

    let leaseLengthError = null;
    if (data.lease_start_date_estimated || data.rent_commencement_estimated) {
        if (!data.lease_length) {
            leaseLengthError = <div style={{color:'red'}}>Required</div>
        }
    }

    return (
        <GridContainer>
            {/* Lease Information */}
			
            {<LeaseCompany 
                renderElement={renderElement}
                data={data}
                setData={setData}
            />}

            <GridItem xs={12} sm={3} md={3}>
                <div className={!props.canEditInvoiceRelatedData ? 'gray-bg-input avoid-clicks' : ''}>
                    {renderElement("lease_start_date", null, warning)}
                </div>
            </GridItem>
            {(data.lease_start_date_estimated || data.rent_commencement_estimated) && (
                <GridItem xs={12} sm={3} md={3}>
                    {renderElement("lease_length", null, warning)}
                    {leaseLengthError}
                </GridItem>
            )}
            <GridItem xs={12} sm={3} md={3}>
                {data.lease_start_date && !isEstimated && <div className={!props.canEditInvoiceRelatedData ? 'gray-bg-input avoid-clicks' : ''}>
                    {renderElement("lease_end_date", null, warning)}
                    {(data.flat_fee_commission !== 'Yes' && !data.lease_end_date) && <div className="red-text">Required</div>}
                </div>}
                {isEstimated && data.lease_start_date && data.lease_length && <CustomInput
                    label="Estimated End Date (read only)"
                    value={moment(data.lease_start_date, 'MM/DD/YYYY').add(parseInt(data.lease_length), 'months').format('MM/DD/YYYY')}
                    readonly={true}
                    readonly_show_gray={true}
                />}
            </GridItem>
            <GridItem xs={12} sm={3} md={3}>
                <div className={!props.canEditInvoiceRelatedData ? 'gray-bg-input avoid-clicks' : ''}>
                    {renderElement("rent_commencement", null, warning)}
                </div>
            </GridItem>
            <GridItem xs={12} sm={3} md={3}>
                {renderElement("total_sf_leased")}
            </GridItem>

            <GridItem xs={12} sm={3} md={3}>
                
            </GridItem>
            <GridItem xs={12} sm={3} md={3}>
                {renderElement("date_lease_signed")}
            </GridItem>
            <GridItem xs={12} sm={3} md={3}>
                {isRenewal ? (
                    <CustomInput label="Occupancy Date" value="Existing" readonly />
                ) : (
                    renderElement("occupancy_date", null, warning)
                )}
            </GridItem>

            <GridItem xs={12} sm={3} md={3}>
                {renderElement("early_possession")}
            </GridItem>
            {data.early_possession === "Yes" && (
                <GridItem xs={12} sm={3} md={3}>
                    {renderElement("early_possession_date")}
                </GridItem>
            )}

            <GridItem xs={12} sm={3} md={3}>
                <div className={!props.canEditInvoiceRelatedData ? 'gray-bg-input avoid-clicks' : ''}>
                    {renderElement("flat_fee_commission")}
                </div>
            </GridItem>
            {data.flat_fee_commission === "Yes" && (
                <GridItem xs={12} sm={3} md={3}>
                    {renderElement("flat_fee_commission_amount")}
                </GridItem>
            )}

            <LeaseRangesBasedOff 
                data={data}
                setData={setData}
            />

            <GridItem xs={12} sm={3} md={3}>
                {renderElement("option_renewal")}
            </GridItem>
            <GridItem xs={12} sm={3} md={3}>
                {renderElement("option_commission")}
            </GridItem>
            <GridItem xs={12} sm={3} md={3}>
                {renderElement("lease_type")}
            </GridItem>

            <GridItem xs={12} sm={3} md={3}>
                {renderElement("contingency")}
            </GridItem>
            {data.contingency === "Yes" && (
                <GridItem xs={12} sm={12} md={12}>
                    {renderElement("contingency_detail")}
                </GridItem>
            )}

			<GridItem xs={12} sm={6} md={6}>
                
            </GridItem>

            <GridItem xs={12} sm={6} md={6}>
                {renderElement("rate_type")}<span style={{position:'relative'}}>
                {get(data, 'rate_type') === 'Fixed Percentage' && (
                    <div className="rate-type">
                        {renderElement("rate_type_cpi_percentage")}
                    </div>
                )}
                </span>
            </GridItem>

            <PreLeaseForm 
                data={data}
                setData={setData}
            />

            {shouldShowRanges && (
                <>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className="group-wrap">
                            <h3>
                                <strong>LEASE TERM &amp; ABATED RENT</strong>
                            </h3>
                            {isEstimated ? <div>{data.lease_length} Months</div> : getDateDifferenceHTML(data)}
                            <hr />
                            {addTermRangesError(data) && <div className="red-text">{addTermRangesError(data)}</div>}
                            <div className={!props.canEditInvoiceRelatedData ? 'gray-bg-input avoid-clicks' : ''}>
                            {!isEstimated && renderElement("lease_term",
                                null, 
                                null, 
                                null, 
                                null, 
                                [], 
                                null, 
                                null,
                                calcs
                            )}
                            {isEstimated && <TermEstimatedMain 
                                                data={data}
                                                calcs={calcs}
                                                updateDataObj={updateDataObj}
                                                setData={setData}
                                            />}
                            </div>
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className="group-wrap">
                            {
                                <div>
                                    <h3>Rent Totals</h3>
                                    <hr />
                                    <Step3RentTotals 
                                        calcs={calcs}
                                    />
                                </div>
                            }
                        </div>
                    </GridItem>
                </>
            )}

            <GridItem xs={12} sm={12} md={12}>
                <div style={{marginTop:20}}>
                    {props.sections ? props.sections.map(s => {
                        if (s.name === 'Lease Information') {
                            if (s.errors) {
                                if (s.errors.length > 0) {
                                    return <div key="lease-info" className="red-text">
                                        {s.errors.join(', ')}
                                    </div>
                                }
                            }
                        }
                        return null
                    }) : null}
                </div>
            </GridItem>

        </GridContainer>
    );
};

function usePrevious(value) {
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    const ref = useRef();
    // Store current value in ref
    useEffect(() => {
        ref.current = value;
    }, [value]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)
    return ref.current;
}

export default Step3;
